/* istanbul ignore file */ import { jsx as _jsx } from "react/jsx-runtime";
import { Column } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import React, { lazy } from "react";
export var LazyContent = /*#__PURE__*/ lazy(function() {
    return import(/* webpackChunkName: "retailer-exclusivity-details-modal-content" */ "./Content").then(function(m) {
        return {
            default: m.Content
        };
    });
});
export var LoadingPlaceholder = function() {
    return /*#__PURE__*/ _jsx(Column, {
        align: "center",
        justify: "center",
        style: {
            height: "600px",
            maxHeight: "100%"
        },
        children: /*#__PURE__*/ _jsx(LoadingSpinner, {})
    });
};
